import store from '../store/store'
import * as util from '../vendor/util'

export const offerMixin = {

    computed: {
        offers() {
            return store.getters.offers;
        }
    },

    methods: {
        applyOfferAndPrices(item, offerAndItem) {
                if (!!offerAndItem) {
                    if (offerAndItem.offer.type === 'priceOffer') {
                        for (let size of item.sizes) {
                            if (('' + size.vol) === ('' + offerAndItem.item.vol)) {
                                //only change the size.price if usecase of the offer is all
                                if (offerAndItem.offer.usecase === 'all') {
                                    size.price = offerAndItem.offer.offerPrice;
                                } else {
                                    if (offerAndItem.offer.usecase === 'takeAway') {
                                        size.takeAwayPrice = offerAndItem.offer.offerPrice;
                                    } else if (offerAndItem.offer.usecase === 'delivery') {
                                        size.deliveryPrice = offerAndItem.offer.offerPrice;
                                    }
                                }

                                //this item contains at least one size which is offered
                                size.offerId = offerAndItem.offer.id;
                                item.offered = true;
                                item.offerId = offerAndItem.offer.id;
                            }
                        }
                    } else if (offerAndItem.offer.type === 'discountOffer') {
                    if (item.extras && item.extras.combinations) {
                        for (let combi of item.extras.combinations) {
                            combi.streichPreis = 1 + combi.price - 1;
                            combi.price = util.calcDiscount(combi, offerAndItem.offer.offerDiscount);

                            item.offered = true;
                            item.offerId = offerAndItem.offer.id;
                        }
                    } else {
                        let firstSize = true;
                        for (let size of item.sizes) {
                            if (offerAndItem.item.vol === '##all##' || ('' + size.vol) === ('' + offerAndItem.item.vol)) {
                                if (offerAndItem.offer.usecase === 'all') {
                                    if (firstSize) {
                                        item.streichPreis = 1 + size.price - 1;
                                    }
                                    size.streichPreis = 1 + size.price - 1;
                                    size.price = util.calcDiscount(size, offerAndItem.offer.offerDiscount);
                                } else {
                                    if (offerAndItem.offer.usecase === 'takeAway') {
                                        size.takeAwayPrice = util.calcDiscount(size, offerAndItem.offer.offerDiscount);
                                    } else if (offerAndItem.offer.usecase === 'delivery') {
                                        size.deliveryPrice = util.calcDiscount(size, offerAndItem.offer.offerDiscount);
                                    }
                                }


                                size.offerId = offerAndItem.offer.id;
                                //this item contains at least one size which is offered
                                item.offered = true;
                                item.offerId = offerAndItem.offer.id;
                            }
                            firstSize = false;
                        }
                        }


                    }
                }
        },

    }

};